import React from "react";
import classNames from "classnames";

import { Button } from "../../atoms/Buttons/Base";
import { Text } from "../../atoms/Text/Text";
import { LoaderIcon } from "../../atoms/Icons/LoaderIcon";

import FriendService from "../../services/Friend/FriendService";

import styles from "./FriendContainer.css";

export class FriendBlockUserNotAuthorized extends React.PureComponent<any> {
  static displayName = "Friend Block User Not Authorized";

  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.setState({ isLoading: false });
  }

  onLoginClick = () => {
    FriendService.redirectToLogin();
  };

  render() {
    if (this.state.isLoading) return <LoaderIcon className={styles.loader} />;

    return (
      <React.Fragment>
        {/* THIS IS TO KEEP CONTAINER ASPECT RATIO BASED ON IMAGE FROM DESIGN */}
        <picture
          className={classNames([
            styles.container_bcg,
            styles.container_bcg__login,
          ])}
          dangerouslySetInnerHTML={{
            __html: `
                            <source srcset="/svg/friends/login_bcg__mobile.png" media="(max-width: 676px)"/>
                            <source srcset="/svg/friends/login_bcg__desktop.png" media="(min-width: 677px)"/>
                            <img src="" width="100%" alt="" role="presentation" />
                        `,
          }}
        />

        <div
          className={styles.container_login}
          data-element-description="Private Friends Network"
        >
          <Text>My Private Friends Network</Text>
          <div className={styles.login_wrapper}>
            <LoginButton
              data-element-description="friend login-button"
              aria-label="Friend Box Login Button"
              onClick={this.onLoginClick}
            >
              <Text size="sd" bold={true}>
                Login
              </Text>
            </LoginButton>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const LoginButton = (props: any) => (
  <Button className={styles.login_button} {...props} />
);
